//Dependencies
import React, { Component } from 'react';

//material-ui
import Grid from '@material-ui/core/Grid';

//Assets
import logo from '../../../static/img/logo.png';

class Header extends Component {
    render() {
        return (
            <div className="header-image">
                <div className="header-container">
                    <Grid container >
                        <Grid item xs={12} >
                            <img src={logo} className="header-logo" />
                        </Grid>
                    </Grid>
                </div>
            </div>
        );
    }
}

export default Header;


// WEBPACK FOOTER //
// ./src/components/PlazoFijo/congrats/Header.js